import React from "react";
import { Card, CardContent } from "../../ui/card";
import { FileTextIcon, WorkflowIcon } from "lucide-react";
import { cn } from "../../../lib/utils";

export type TestSetType = "request" | "workflow";

interface TestSetTypeStepProps {
  value?: TestSetType;
  onChange: (type: TestSetType) => void;
}

const TestSetTypeStep: React.FC<TestSetTypeStepProps> = ({ value, onChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-gc-med text-foreground mb-2">
          Test Set Type
        </h3>
        <p className="text-sm text-muted-foreground">
          Choose whether to create a test set from chat completion requests or from workflow sessions.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card
          className={cn(
            "cursor-pointer transition-all hover:border-maitai-green/50",
            value === "request"
              ? "border-maitai-green bg-maitai-green/5"
              : "border-border"
          )}
          onClick={() => onChange("request")}
        >
          <CardContent className="p-6">
            <div className="flex items-start gap-4">
              <div
                className={cn(
                  "flex items-center justify-center w-12 h-12 rounded-lg",
                  value === "request" ? "bg-maitai-green text-white" : "bg-muted"
                )}
              >
                <FileTextIcon className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <h4 className="font-gc-med text-foreground">Request</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Create a test set from chat completion requests. Select an intent group and choose requests manually or sample from a dataset.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card
          className={cn(
            "cursor-pointer transition-all hover:border-maitai-green/50",
            value === "workflow"
              ? "border-maitai-green bg-maitai-green/5"
              : "border-border"
          )}
          onClick={() => onChange("workflow")}
        >
          <CardContent className="p-6">
            <div className="flex items-start gap-4">
              <div
                className={cn(
                  "flex items-center justify-center w-12 h-12 rounded-lg",
                  value === "workflow" ? "bg-maitai-green text-white" : "bg-muted"
                )}
              >
                <WorkflowIcon className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <h4 className="font-gc-med text-foreground">Workflow</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  Create a test set from workflow sessions. Select a workflow and import sessions to convert into workflow runs for benchmarking.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TestSetTypeStep;
